import React from 'react';
import useWebsiteSetting , {useWhyChoosedata} from "../FetchAPI";


export default function DataContent() {
    const [whyChoosedata] = useWhyChoosedata();
    const [webSetting] = useWebsiteSetting();

  return (
    <>
      {/* Why Choose Us Section Start */}

      <section className="why_section_new">
        <div className="container">

          <div className="why_heading_area">
            <span className="why_subtitle">WHY CHOOSE US</span>

            <h2 className="why_main_title">
              {webSetting.whyChoose_title}
            </h2>

            <p className="why_desc">
              Trusted and reliable services with complete documentation support.
            </p>
          </div>

          <div className="row g-4">

            <div className="col-lg-3 col-md-6">
              <div className="why_card_new">

                <span className="why_number">01</span>

                <div className="why_icon_box">
                  <img
                    src={whyChoosedata.stap1_img}
                    alt=""
                    className="why_icon_img"
                  />
                </div>

                <h4>{whyChoosedata.stap1_title}</h4>

                <p>{whyChoosedata.stap1_tagline}</p>

              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="why_card_new">

                <span className="why_number">02</span>

                <div className="why_icon_box">
                  <img
                    src={whyChoosedata.stap2_img}
                    alt=""
                    className="why_icon_img"
                  />
                </div>

                <h4>{whyChoosedata.stap2_title}</h4>

                <p>{whyChoosedata.stap2_tagline}</p>

              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="why_card_new">

                <span className="why_number">03</span>

                <div className="why_icon_box">
                  <img
                    src={whyChoosedata.stap3_img}
                    alt=""
                    className="why_icon_img"
                  />
                </div>

                <h4>{whyChoosedata.stap3_title}</h4>

                <p>{whyChoosedata.stap3_tagline}</p>

              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="why_card_new">

                <span className="why_number">04</span>

                <div className="why_icon_box">
                  <img
                    src={whyChoosedata.stap4_img}
                    alt=""
                    className="why_icon_img"
                  />
                </div>

                <h4>{whyChoosedata.stap4_title}</h4>

                <p>{whyChoosedata.stap4_tagline}</p>

              </div>
            </div>

          </div>

        </div>
      </section>
      {/* Why Choose Us Section End */}



    </>
  );
}
